package com.arena_web.data.repository

import com.arena_web.data.api.WalletApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.WalletRepository

class WalletRepositoryImpl(private val walletApi: WalletApi) : WalletRepository {

    override suspend fun getWallet(): Result<WalletDto> =
        apiCall { walletApi.getWallet() }

    override suspend fun checkout(request: WalletCheckoutRequest): Result<WalletCheckoutDto> =
        apiCall { walletApi.checkout(request) }

    override suspend fun confirmCheckout(request: WalletConfirmRequest): Result<WalletConfirmDto> =
        apiCall { walletApi.confirmCheckout(request) }

    override suspend fun getTransactions(limit: Int, offset: Int): Result<List<WalletTransactionDto>> =
        apiCall { walletApi.getTransactions(limit, offset) }
}
